'use client';

import { EventTypes } from '@/@types';
import React, { useContext, useMemo, useRef } from 'react';

const Context = React.createContext<undefined | HTMLElement>(undefined);

export const EventContext: React.FC<React.PropsWithChildren> = ({ children }) => {
  const target = useRef(typeof window !== 'undefined' ? window.document.body : undefined);
  return <Context.Provider value={target.current}>{children}</Context.Provider>;
};

export const useEvent = () => {
  const target = useContext(Context);
  const value = useMemo(() => {
    if (!target) {
      return {
        addEventListener: () => {},
        removeEventListener: () => {},
        dispatchEvent: () => {},
      };
    }
    return {
      addEventListener: (event: EventTypes, callback: any) => {
        return target.addEventListener(event, callback);
      },
      removeEventListener: (event: EventTypes, callback: any) => {
        return target.removeEventListener(event, callback);
      },
      dispatchEvent: (event: EventTypes, data?: any) => {
        return target.dispatchEvent(new CustomEvent(event, { detail: data }));
      },
    };
  }, [target]);
  return value;
};
